import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, title }) => {
  return (
    <div
      style={{
        maxWidth: 1350,
        margin: '0 auto',
        padding: '60px 40px',
      }}
    >
      {title && (
        <h2
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 300,
            fontSize: 'clamp(20px, 3vw, 32px)',
            color: '#ffffff',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            textAlign: 'center',
            marginBottom: 48,
          }}
        >
          {title}
        </h2>
      )}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 32,
        }}
      >
        {products.map((product, index) => (
          <ProductCard key={product.id} product={product} isFirst={index === 0} isSecond={index === 1} isThird={index === 2} />
        ))}
      </div>
    </div>
  );
};

export default ProductGrid;
